class CursoEscala {
  constructor(dados) {
    this.idCurso = dados ? dados.idCurso : null;
    this.idEscala = dados ? dados.idEscala : null;
  }
}
export default CursoEscala;
